import { HttpParams, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnumEstadoMatricula } from '../models/enumEstadoMatricula';
import { MatriculaListItemDTOICollectionPagedResponse } from '../models/matriculaListItemDTOICollectionPagedResponse';

@Injectable({
  providedIn: 'root',
})
export class MatriculaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  // List all Matricula
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllMatricula`,
        params
          ? new HttpParams({
            fromObject: params,
          })
          : this.params
      )
      .pipe(map((response) => response.data));
  }

  public getAllMatriculaGet(pageNumber?: number, pageSize?: number, orderBy?: string, bolsaInstituicaoCursoID?: number, idAnoLectivo?: number, estado?: EnumEstadoMatricula, anoCurricular?: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean }): Observable<MatriculaListItemDTOICollectionPagedResponse> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber?.toString() || '')
      .set('pageSize', pageSize?.toString() || '')
      .set('orderBy', orderBy || '')
      .set('bolsaInstituicaoCursoID', bolsaInstituicaoCursoID?.toString() || '')
      .set('idAnoLectivo', idAnoLectivo?.toString() || '')
      .set('estado', estado?.toString() || '')
      .set('anoCurricular', anoCurricular || '');

    return this.apiService.get<MatriculaListItemDTOICollectionPagedResponse>(
      `${this.path}/getAllMatricula`
    );
  }

  // Create new Matricula
  public store(form: any): Observable<any> {
    const matricula = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddMatricula`, matricula)
      .pipe(map((response) => response.object));
  }

  // Trocar ano da Matricula
  public trocarAnoLectivoMatricula(form: any): Observable<any> {
    const matricula = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/TrocarAnoLectivoMatricula`, matricula)
      .pipe(map((response) => response.object));
  }

  // Update existing Matricula
  public update(form: FormGroup, id: string): Observable<any> {
    const matricula = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateMatricula/${id}`, matricula)
      .pipe(map((response) => response.object));
  }

  // Delete existing Matricula
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteMatriculaById/${id}`);
  }

  // Get Matricula by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getMatriculaById/${id}`)
      .pipe(map((response) => response.object));
  }
}
